/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_DiscussionInputs */

const en_community_discussion = /** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Discussion`)
};

const es_community_discussion = /** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discusión de la Comunidad`)
};

const fr_community_discussion = /** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion de la communauté`)
};

const de_community_discussion = /** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Diskussion`)
};

const id_community_discussion = /** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskusi Komunitas`)
};

/** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */
const ja_community_discussion = en_community_discussion;

/** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */
const zh_community_discussion = en_community_discussion;

/** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */
const ar_community_discussion = en_community_discussion;

/** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */
const it_community_discussion = en_community_discussion;

/** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */
const ru_community_discussion = en_community_discussion;

/** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */
const pt_community_discussion = en_community_discussion;

/** @type {(inputs: Community_DiscussionInputs) => LocalizedString} */
const ko_community_discussion = en_community_discussion;

/**
* | output |
* | --- |
* | "Community Discussion" |
*
* @param {Community_DiscussionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_discussion = /** @type {((inputs?: Community_DiscussionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_DiscussionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_discussion(inputs)
	if (locale === "es") return es_community_discussion(inputs)
	if (locale === "fr") return fr_community_discussion(inputs)
	if (locale === "de") return de_community_discussion(inputs)
	if (locale === "ja") return ja_community_discussion(inputs)
	if (locale === "zh") return zh_community_discussion(inputs)
	if (locale === "ar") return ar_community_discussion(inputs)
	if (locale === "id") return id_community_discussion(inputs)
	if (locale === "it") return it_community_discussion(inputs)
	if (locale === "ru") return ru_community_discussion(inputs)
	if (locale === "pt") return pt_community_discussion(inputs)
	return ko_community_discussion(inputs)
});